import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';

class DialogTitle extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <div className="Dialog-title">
                <h3>{this.props.title}</h3>
            </div>
        );
    }
}

DialogTitle.propTypes = {
    title: PropTypes.string.isRequired
};

export default DialogTitle;



// WEBPACK FOOTER //
// ./frontend/src/js/components/dialog/DialogTitle.jsx